import React, {useState} from 'react';
import Modal, { useModal } from '../../Components/Modal';
import { useBalance, useSMSBundles } from '../../Data/Balance';
import { PageLoading } from '../../Components/Loading';
import Money from '../../Components/Formatting/Money';
import { numFormat } from '../../Services/helpers';
import Button from '../../Components/Button/Button';
import CustomSelect from '../../Components/Containers/CustomSelect';
import ButtonRow from '../../Components/Button/ButtonRow';
import { useSession } from '../../Components/Session';
import Alert from '../../Components/Alert';
import Toggle from '../../Components/Button/Toggle';

const AddSMSCredits = ({isOpen, setIsOpen, onComplete}) => {
    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Top up SMS" dismissible>
        {isOpen && <Inner {...{onComplete}} />}
    </Modal>
}

const Inner = ({onComplete}) => {
    const {closeModal} = useModal();
    const {bundles} = useSMSBundles();
    const {purchaseSMSBundle, isSaving, balance} = useBalance();
    const [selected, setSelected] = useState(balance?.autoTopUpSMS ?? null);
    const {hasFeature} = useSession();
    const [autoTopUp, setAutoTopUp] = useState(!!(balance?.autoTopUpSMS ?? null));

    if (!bundles) {
        return <PageLoading />;
    }

    const handlePurchase = async () => {
        await purchaseSMSBundle(selected, autoTopUp);
        onComplete && onComplete();
        closeModal();
    }

    return <>
        {hasFeature('LOWEST_SMS_COST') && <Alert
            theme="info"
            icon="PartyHorn"
            title={null}
            className="text-sm"
            message="Your plan includes cheaper SMS bundles. You'll always pay the lowest price on all bundle sizes."
        />}

        <CustomSelect
            isDisabled={isSaving}
            onChange={setSelected}
            selected={selected}
            options={bundles.map(bundle => ({
                value: bundle.count,
                body: <div className="grid grid-cols-2 items-center">
                    <div className="text-lg text-brand font-bold">
                        {numFormat(bundle.count)} SMS
                    </div>
                    <div className="leading-4">
                        <Money pence={bundle.cost} /><br />
                        {bundle.save > 0 && <span className="text-muted text-sm">
                            Save <Money pence={bundle.save} />
                        </span>}
                    </div>
                </div>
            }))}
        />
        <Toggle label="Auto top up"
            enabled={autoTopUp}
            onChange={setAutoTopUp}
            help={(autoTopUp && selected) ?
                `When your balance drops below 50 SMS credits it will automatically be topped up by ${numFormat(selected)} SMS credits.` :
                'You will need to top up manually when your balance gets low.'
            }
            ring
        />
        <ButtonRow>
            <Button theme="secondary" label="Cancel" onClick={() => closeModal()} disabled={isSaving} />
            <Button theme="primary" label="Add" onClick={() => handlePurchase()} loading={isSaving} />
        </ButtonRow>
    </>

}

export default AddSMSCredits;
